var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileSvg07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75H2.25C1.85218 2.75 1.47064 2.90804 1.18934 3.18934C0.908035 3.47064 0.75 3.85218 0.75 4.25V13.25C0.75 13.6478 0.908035 14.0294 1.18934 14.3107C1.47064 14.592 1.85218 14.75 2.25 14.75H9.75C10.1478 14.75 10.5294 14.592 10.8107 14.3107C11.092 14.0294 11.25 13.6478 11.25 13.25V4.25C11.25 3.85218 11.092 3.47064 10.8107 3.18934C10.5294 2.90804 10.1478 2.75 9.75 2.75H8.25",
    stroke: "#182EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.75V8M6 11.75V11M8.25 11.75V9.5M3.75 2.75C3.75 2.35218 3.90804 1.97064 4.18934 1.68934C4.47064 1.40804 4.85218 1.25 5.25 1.25H6.75C7.14782 1.25 7.52936 1.40804 7.81066 1.68934C8.09196 1.97064 8.25 2.35218 8.25 2.75C8.25 3.14782 8.09196 3.52936 7.81066 3.81066C7.52936 4.09196 7.14782 4.25 6.75 4.25H5.25C4.85218 4.25 4.47064 4.09196 4.18934 3.81066C3.90804 3.52936 3.75 3.14782 3.75 2.75Z",
    stroke: "#182EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSvg07);
export default __webpack_public_path__ + "static/media/profile-svg07.d5fc391987ff1a695875a677d6d65b33.svg";
export { ForwardRef as ReactComponent };